'use strict';exports.__esModule = true;exports.getViewLevelByZoom = exports.filterStreetFeatures = exports.savePolygonToStorage = exports.isLocationChanged = exports.formatLocationMap = exports.formatLocationSearch = exports.formatLocationPoint = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _constants = require('../../constants');
var _constants2 = require('../../services/MapboxService/constants');
var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatLocationPoint = exports.formatLocationPoint = function formatLocationPoint(_ref) {var _ref$lat = _ref.lat,lat = _ref$lat === undefined ? 0 : _ref$lat,_ref$lon = _ref.lon,lon = _ref$lon === undefined ? 0 : _ref$lon;return {
    lat: Number(lat.toFixed(5)),
    lon: Number(lon.toFixed(5)) };};


var formatLocationSearch = exports.formatLocationSearch = function formatLocationSearch(locationSearch) {
  var point = (0, _get2.default)(locationSearch, 'location', {});
  return formatLocationPoint(point);
};

var formatLocationMap = exports.formatLocationMap = function formatLocationMap(locationSearch) {
  var topright = (0, _get2.default)(locationSearch, 'map.topright', {});
  var bottomleft = (0, _get2.default)(locationSearch, 'map.bottomleft', {});
  return {
    topright: formatLocationPoint(topright),
    bottomleft: formatLocationPoint(bottomleft) };

};

var isLocationChanged = exports.isLocationChanged = function isLocationChanged(locationSearch, oldLocationSearch) {
  var newLocation = formatLocationSearch(locationSearch);
  var oldLocation = formatLocationSearch(oldLocationSearch);
  return !(0, _isEqual2.default)(newLocation, oldLocation);
};

var savePolygonToStorage = exports.savePolygonToStorage = function savePolygonToStorage(coords, bounds) {
  try {
    var polygonData = JSON.stringify({ coords: coords, bounds: bounds });
    _constants.storage.value.setItem('polygonCoordinates', polygonData);
  } catch (err) {
    console.error(err);
  }
};

var processStreetName = function processStreetName() {var street = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return street.
  trim().
  toLowerCase().
  replace(/'/gi, '').
  replace(/ /gi, '-');};

var matchFeature = function matchFeature() {var featureName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var streetName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';return featureName && (
  featureName === streetName ||
  featureName.includes(streetName) ||
  streetName.includes(featureName));};


var matchEnFeature = function matchEnFeature(feature) {var enStreet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var featureName = processStreetName((0, _get2.default)(feature, 'properties.name_en', ''));
  var streetName = processStreetName(enStreet);

  return matchFeature(featureName, streetName);
};

var matchHeFeature = function matchHeFeature(feature, heStreet) {
  var featureName = processStreetName((0, _get2.default)(feature, 'properties.name', ''));
  var streetName = processStreetName(heStreet);

  return matchFeature(featureName, streetName);
};

var filterStreetFeatures = exports.filterStreetFeatures = function filterStreetFeatures(features, locationSearch) {
  var enStreetName = (0, _get2.default)(locationSearch, 'en.street_name');
  var heStreetName = (0, _get2.default)(locationSearch, 'he.street_name');

  return features.filter(function (feature) {return (
      matchEnFeature(feature, enStreetName) ||
      matchHeFeature(feature, heStreetName));});

};

var getViewLevelByZoom = exports.getViewLevelByZoom = function getViewLevelByZoom(zoomValue) {return zoomValue < _constants2.MAX_CITY_ZOOM ? 'city' : 'neighborhood';};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MapContainer/helpers.js
// module id = 2985
// module chunks = 0